PegasusTemplate.HistoryNavigator = Em.Mixin.create({
  actions: {
    requestRoll: function(params){
      PegasusTemplate.Helpers.addOneTimeObserver(PegasusTemplate.stateMachine, 'currentPath', 'saved', function(){
        Em.run.scheduleOnce( 'afterRender', null, function(){
          Em.get( PegasusTemplate.CommandManager, 'instance' ).rollTo(params.payload.position);
        });
      });

      PegasusTemplate.stateMachine.send('didFinishEditing');
    }
  }
});

PegasusTemplate.IOEventsMixin = Em.Mixin.create({
  templateLoaded: function(){
    this.say(window.parent, {
      method: 'receiveContextLoaded',
      payload: {}
    });
  },
  actions: {
    requestTemplateOutput: function(params){
      var result = PegasusTemplate.IOManager.generateOutput(params.payload.forSending);
      this.say( window.parent, {
        method: 'receiveTemplateOutput',
        payload: {
          output: result
        }
      });
    }
  }
});

PegasusTemplate.FrameReceivedEventsMixin = Em.Mixin.create({
  templateContext: function(){
    return {
      type: window.editorDocumentType,
      id: '',
      selectableContactLists: [],
      showHints: true,
      forwardInstruction: 'Send E-Mail',
      fields: {},
      template: window.vr_template()
    };
  }.property(),

  replaceImage: function(handler){
    this.say(window.parent, {
      method: 'requestReplaceImage',
      payload: handler
    });
  },

  editBlock: function(properties) {
    properties.defaultListId = this.get('controllers.toolbar.defaultListId');
    properties.touched = false;
    properties.templateColors = findCanvasColors().uniq();
    properties.userSelectedColors = this.get('controllers.toolbar.userSelectedColors');
    properties.showForwardEmailOption = this.get('controllers.toolbar.showForwardEmailOption');

    this.say(window.parent, {
      method: 'editBlock',
      payload: properties
    });
  },

  broadcastHiddenState: function(state){
    this.say(window.parent, {
      method: 'receiveHiddenState',
      payload: {
        hasHidden: state
      }
    });
  },

  paletteProperties: function(){
    var controller = PegasusTemplate.lookupController('toolbar'),
      intrinsicTemplateWidth = PegasusTemplate.lookupController('template').get('intrinsicTemplateWidth');

    return {
      isShowingShadow: controller.get('isShowingShadow'),
      selectedPrimaryColor: controller.get('selectedPrimaryColor'),
      selectedSecondaryColor: controller.get('selectedSecondaryColor'),
      templateColors: findCanvasColors().uniq(),
      userSelectedColors: controller.get('userSelectedColors'),
      touched: false,
      selectedIsAnimatedGif: controller.get('selectedIsAnimatedGif'),
      selectedBackgroundColor: controller.get('selectedBackgroundColor'),
      successActionId: controller.get('successActionId'),
      successActionRedirectURL: controller.get('successActionRedirectURL'),
      selectedCloseAlignment: controller.get('selectedCloseAlignment'),
      selectedCloseButton: controller.get('selectedCloseButton'),
      selectedBorderRadiusOption: controller.get('selectedBorderRadiusOption'),
      intrinsicTemplateWidth: intrinsicTemplateWidth,
      selectedTemplateWidth: controller.get('selectedTemplateWidth'),
      selectedTemplateAutoHeight: controller.get('selectedTemplateAutoHeight'),
      selectedTemplateHeight: controller.get('selectedTemplateHeight'),
      selectedBorderWidth: controller.get('selectedBorderWidth'),
      selectedBorderColor: controller.get('selectedBorderColor'),
      selectedBorderRadius: controller.get('selectedBorderRadius'),
      selectedShadowSpreadRadius: controller.get('selectedShadowSpreadRadius'),
      selectedShadowBlurRadius: controller.get('selectedShadowBlurRadius'),
      generatedBackdropStyle: controller.get('generatedBackdropStyle'),
      selectedBackgroundImageStyle: controller.get('selectedBackgroundImageStyle'),
      selectedBackgroundImage: controller.get('selectedBackgroundImage'),
      selectedBackgroundImageCovers: controller.get('selectedBackgroundImageCovers'),
      selectedFontFace: controller.get('selectedFontFace'),
      selectedBlockRegionColor: controller.get('selectedBlockRegionColor'),
      selectedBlockRegionImage: controller.get('selectedBlockRegionImage'),
      selectedBlockRegionImageAnimated: controller.get('selectedBlockRegionImageAnimated'),
      selectedBlockRegionImageStyle: controller.get('selectedBlockRegionImageStyle'),
      selectedBlockRegionImageCovers: controller.get('selectedBlockRegionImageCovers'),
      selectedBlockRegionImageAttachment: controller.get('selectedBlockRegionImageAttachment'),
      selectedTemplateAppearance: controller.get('selectedTemplateAppearance'),
      selectedRowColor: controller.get('selectedRowColor'),
      footerAnchorColor: controller.get('footerAnchorColor'),
      footerLabelColor: controller.get('footerLabelColor'),
      preview_url: controller.get('preview_url'),
      isAuthorizedToRemoveLogo: controller.get('isAuthorizedToRemoveLogo'),
      userLevelLogoHidden: controller.get('userLevelLogoHidden'),
      showForwardEmailOption: controller.get('showForwardEmailOption'),
      isFooterLogoEnabled: controller.get('isFooterLogoEnabled'),
      ogpTitle: controller.get('ogpTitle'),
      ogpDescription: controller.get('ogpDescription'),
      ogpImage: controller.get('ogpImage'),
      payload: {
        type: PegasusTemplate.loadedTemplate().get('paletteType')
      }
    };
  },

  blocks: null,

  requestTemplateWidth: function(callback) {
    this.say(window.parent, {
      method: 'requestTemplateWidth',
      payload: {

      }
    });
  },

  actions: {
    receiveShowHidden: function(params) {
      PegasusTemplate.lookupController( 'template' ).set('revealHidden', true);
    },
    receiveHideHidden: function(params) {
      PegasusTemplate.lookupController( 'template' ).set('revealHidden', false);
    },
    receiveClearTemplateRows: function(params){
      PegasusTemplate.lookupController('toolbar').clearRows();
    },
    requestBecomeInactiveDocument: function(){
      PegasusTemplate.stateMachine.send('didFinishEditing');
    },
    requestBecomeActiveDocument: function(){
      Em.get( PegasusTemplate.CommandManager, 'instance').broadcastCurrent();
    },
    registerEmberFrame: Em.K,
    requestEditorContext: function(params){
      this.say(params.requestSource, {
        method: 'receiveEditorContext',
        payload: this.get('templateContext')
      });
    },

    requestWidgetCode: function(){
      this.say(window.parent, {
        method: 'requestWidgetCode',
        payload: {}
      });
    },

    editPalette: function(){
      this.say(window.parent, {
        method: 'editPalette',
        payload: this.paletteProperties()
      });
    },

    editFooter: function(){
      PegasusTemplate.stateMachine.transitionTo('editing.footer', PegasusTemplate.canvasInstance.get('footerView'));
    },

    addRow: function(){
      var blocks = this.get('blocks');
      var blacklist = PegasusTemplate.lookupController('toolbar').get('blacklistBlocks') || [];
      if ( ! blocks ) {
        blocks = this.get('store').all(PegasusTemplate.Block).filter(function(item){
          return blacklist.indexOf(item.get('name')) === -1;
        }).map(function(item){
          return item.serialize();
        });

        this.set('blocks', blocks);
      }

      this.say(window.parent, {
        method: 'addRow',
        payload: {
          blocks: blocks,
          payload: {
            type: 'Blocks'
          }
        }
      });
    },

    requestEditPalette: function(){
      PegasusTemplate.Helpers.addOneTimeObserver(PegasusTemplate.stateMachine, 'currentPath', 'saved', function(){
        Em.run.scheduleOnce('afterRender', PegasusTemplate.stateMachine, 'transitionTo', 'editing.palette');
      });

      PegasusTemplate.stateMachine.send('didFinishEditing');
    },

    requestDidFinishEditing: function(){
      this.say(window.parent, {
        method: 'editBlock',
        payload: {
          payload: {
            type: 'emptyView'
          }
        }
      });
    },

    didShowBlocks: false,

    enteredIdleState: function(){
      // We want "Blocks" to be the first tab the user sees
      if ( !this.get('didShowBlocks') ) {
        this.set('didShowBlocks', true);
        this.send('addRow');
        return;
      }

      this.say(window.parent, {
        method: 'editBlock',
        payload: {
          payload: {
            type: 'emptyView'
          }
        }
      });
    },

    requestRowAddition: function(){
      PegasusTemplate.Helpers.addOneTimeObserver(PegasusTemplate.stateMachine, 'currentPath', 'saved', function(){
        Em.run.scheduleOnce('afterRender', PegasusTemplate.stateMachine, 'transitionTo', 'addingRow');
      });

      PegasusTemplate.stateMachine.send('didFinishEditing');
    },

    requestPaletteData: function(){
      this.say(window.parent, {
        method: 'receivePaletteData',
        payload: this.paletteProperties()
      });
    },

    requestIntrinsicWidthBreach: function(params){
      this.say(window.parent, {
        method: 'requestIntrinsicWidthBreach',
        payload: params
      });
    },

    receiveAddRow: function(params){
      var cookie = params.payload.cookie,
        position = PegasusTemplate.blockRegionInstance.get('childViews.length');

      var command = PegasusTemplate.AddRowCommand.create({
        klass: PegasusTemplate.loadedTemplate().rowClass(),
        sourceElement: cookie,
        desiredPosition: position
      });

      command.execute();

      var blockName = cookie.slice( cookie.search('name='), cookie.length ).split('"')[1];
      var block = PegasusTemplate.lookupStore().blockForName( blockName );
      var intrinsicWidth = block.get('intrinsic_width');
      var templateWidth = PegasusTemplate.lookupController('toolbar').get('selectedTemplateWidth');
      if ( block &&
          intrinsicWidth &&
          intrinsicWidth > templateWidth ) {

        Em.run.scheduleOnce(
          'afterRender',
          this,
          'send',
          'requestIntrinsicWidthBreach', {
            intrinsicTemplateWidth: intrinsicWidth,
            electedTemplateWidth: templateWidth
          }
        );
      }

      $('body').scrollTo( $('.vr-row').last() );
    },

    requestImageTransformation: function(params) {
      var self = this;

      $.ajax({
        url:'/image_transformations/encode_64',
        type:'POST',
        dataType: 'json',
        contentType: "application/json",
        xhrFields: {
          withCredentials: true
        },
        data: JSON.stringify({
          custom_url: params.payload.url,
          style: "original"
        })
      }).done(function(data, state, response){
        self.say(params.requestSource, {
          method: 'receiveImageTransformation',
          payload: {
            isSuccess: true,
            data: data
          }
        });
      }).fail(function(response, resultType, errorMessage){
        self.say(params.requestSource, {
          method: 'receiveImageTransformation',
          payload: {
            isSuccess: false,
            data: response
          }
        });
      });
    },

    requestReplaceColors: function(params){
      PegasusTemplate.lookupController('toolbar').didReplaceColors(params.payload);
      Em.run.scheduleOnce('afterRender', this, 'send', 'editPalette');
    },

    receiveEdit: function(params) {
      PegasusTemplate.stateMachine.send('hideControls');

      var controller = PegasusTemplate.lookupController('toolbar');
      controller.setProperties(params.payload);

      if ( params.payload.selectedPrimaryColor ) {
        controller.didChangePrimaryColor( params.payload.selectedPrimaryColor );
        this.send('requestPaletteData');
      }

      if ( params.payload.selectedSecondaryColor ) {
        controller.didChangeSecondaryColor( params.payload.selectedSecondaryColor );
        this.send('requestPaletteData');
      }

      if ( params.payload.selectedRowColor ) {
        controller.didChangeSelectedRowColor( params.payload.selectedRowColor );
        this.send('requestPaletteData');
      }
    },

    sendHistory: function(history){
      this.say(window.parent, {
        method: 'receiveHistory',
        payload: history
      });
    },

    requestTemplateImages: function(params){
      var controller = this;
      var results = [];
      var requestor = params.requestSource;

      var addImagesFromProperty = function(property){
        var workingImage = $('<img>');
        var workingSrc = controller.get(property);

        if ( !workingSrc ) { return; }

        workingImage.attr('src', workingSrc);

        workingImage.imagesLoaded().always(function(img){
          controller.say(requestor, {
            method: 'receiveTemplateImages',
            payload: {
              thumbnail: img.images[0].img.src,
              src: img.images[0].img.src,
              aspectRatio: img.images[0].img.naturalWidth/img.images[0].img.naturalHeight
            }
          });
        });
      };

      var addImagesFromAttr = function(attr){
        $('[' + attr + ']').each(function(_, i){
          var workingImage = $('<img>');
          var item = $(i);
          var workingSrc = item.attr(attr);

          if ( !workingSrc ) { return; }

          workingImage.attr('src', workingSrc);

          workingImage.imagesLoaded().always(function(img){
            controller.say(requestor, {
              method: 'receiveTemplateImages',
              payload: {
                thumbnail: img.images[0].img.src,
                src: img.images[0].img.src,
                aspectRatio: img.images[0].img.naturalWidth/img.images[0].img.naturalHeight
              }
            });
          });
        });
      };

      addImagesFromAttr( 'data-src' );
      addImagesFromAttr( 'data-background-image' );

      addImagesFromProperty( 'controllers.toolbar.selectedBackgroundImage' );
      addImagesFromProperty( 'controllers.toolbar.selectedBlockRegionImage' );
    },

    didLoadEditor: Em.K,
    receiveEditorContext: function(params){
      this.set('templateContext', params.payload);

      var uri = $('<a>').attr('href', window.location.href.strip('/'))[0];
      var host = location.protocol + '//' + uri.host;

      Em.run(this, function(){
        this.set('controllers.template.isSaving', false);
        this.get('controllers.toolbar').setProperties(params.payload);

        PegasusTemplate.set('options', params.payload);
        PegasusTemplate.set('formSubmissionHost', params.payload.assetHost);
        PegasusTemplate.set('templateAssetHost', host);
        Em.set(PegasusTemplate.stateMachine, 'shouldShowHelp', params.payload.showHints);
        PegasusTemplate.stateMachine.initialize();
      });
    }
  },

  sendTemplateRenderingOptions: function(){
    this.say(window.parent, {
      method: 'receiveTemplateRenderingOptions',
      payload: this.paletteProperties()
    });
  },

  reset: function(){
    PegasusTemplate.reset();
  },

  requestHandoff: function(params){
    var handoffEmail = this.get('handoffPayload');

    this.say(params.requestSource, {
      method: 'receiveHandoff',
      payload: {
        template: $.extend( {
          name: 'Untitled Draft Email',
          subject: 'Untitled Email',
          handoff: true /* let responder know this is an email created from a remote context */
        }, handoffEmail )
      }
    });
  },

  handoffMessage: null,

  requestSaveSnapshot: function(params){
    if ( window.parent !== window ) {
      this.say(window.parent, {
        method: 'receiveSnapshot',
        payload: {
          template: $.extend( {
            handoff: false /* let responder know this is an email created from a remote context */
          }, params)
        }
      });
      return;
    }

    this.set('handoffMessage', Em.I18n.t('instructions.signup_to_save_your_work'));
    PegasusTemplate.lookupRouter().send('saveAndContinue');
    Em.run.later( this, 'didSaveSnapshot', 1000);
  },

  didSaveSnapshot: function(){
    $('.saving-mask').remove();

    if ( this.get('pendingAction') ) {
      this.send( this.get('pendingAction') );
    }

    this.get('controllers.autoSave').updateLastSaved();
  },

  demandFormDefaultList: function(params) {
    var controller = this.get('controllers.toolbar');
    this.set('controllers.template.isSaving', false);

    params.payload.newListName = [ Em.I18n.t('g.invalid_list_name') ];

    PegasusTemplate.lookupController('modal').set('presenter', PegasusTemplate.DefaultListModal.create({
      controller: controller,
      params: params,
      errors: params.payload
    }));
  },

  demandFooterFields: function(params) {
    this.set('controllers.toolbar.errors', params.payload);
    this.set('controllers.template.isSaving', false);

    PegasusTemplate.lookupController('modal').set('presenter', PegasusTemplate.FooterFieldsModal.create({
      controller: this.get('controllers.toolbar')
    }));
  },

  didDeleteUserImage: Em.K,
  receiveSnapshot: function(){
    this.didSaveSnapshot();
  },

  requestUpgradeModal: function(){
    if( this.get('controllers.autoSave').saveSnapshot() ) {
      this.set('pendingAction', 'requestUpgradeModal' );
      return;
    }

    this.say(window.parent, {
      method: 'requestUpgrade',
      payload: {}
    });
  },

  requestUpgrade: Em.K,

  upgradeCancelled: function(){
    $('.logo-hider .switch-candy').click();
  },

  createContactList: function(listData){
    this.say(window.parent, {
      method: 'createContactList',
      payload: listData
    });
  },

  contactListCreated: function(params){
    var view = this.get('controllers.toolbar.designBoundView');
    if ( view ) {
      view.set('dataFormListId', params.payload.id);
      view.set('selectedList', params.payload);
    }

    this.get('controllers.toolbar.selectableContactLists').pushObject( params.payload );
  }
});

PegasusTemplate.FrameCommManagerController = Em.Controller.extend(PegasusTemplate.IOEventsMixin, PegasusTemplate.HistoryNavigator, PegasusTemplate.FrameReceivedEventsMixin, {
  needs: ['toolbar', 'autoSave', 'template'],
  init: function(){
    this._super();
    this.say(window.parent, {
      method: 'registerEmberFrame',
      payload: {
        id: 'pegasus_template' // this must match parent-side
      }
    });
  },
  listen: function(message){
    var data = message.data;
    var requestedMethod = data.method;

    if ( !requestedMethod ) { return; }

    // must have a payload
    // note this filters standard message events
    var payload = data.payload;

    this.send(requestedMethod, {
      payload: payload,
      requestSource: message.source
    });
  },
  say: function(target, message){
    target.postMessage( message, '*' );
  }
});
